import React from 'react';
import { Link } from 'react-router-dom';

export default function Landing({ user }) {
  return (
    <div style={{minHeight:'100vh',background:'linear-gradient(135deg,#F0FDF4,#FEF9C3)'}}>
      <nav className="nav">
        <a className="nav-brand" href="/">
          <div className="nav-logo">🏘</div>
          <div className="nav-name">Community<span>Bridge</span></div>
        </a>
        <div className="nav-links">
          {user ? <Link to="/dashboard" className="btn btn-primary">Dashboard</Link> : <>
            <Link to="/login" className="btn btn-secondary">Login</Link>
            <Link to="/signup" className="btn btn-primary">Join Free</Link>
          </>}
        </div>
      </nav>
      <div style={{maxWidth:'1100px',margin:'0 auto',padding:'4rem 1rem'}}>
        <div style={{textAlign:'center',marginBottom:'4rem'}}>
          <div style={{fontSize:'72px',marginBottom:'1rem'}}>🏘</div>
          <h1 style={{fontSize:'clamp(28px,5vw,60px)',fontWeight:800,lineHeight:1.1,marginBottom:'1rem'}}>
            Stronger communities,<br/><span style={{color:'#16A34A'}}>one neighbor at a time</span>
          </h1>
          <p style={{fontSize:'18px',color:'#4B5563',maxWidth:'600px',margin:'0 auto 2rem',lineHeight:1.7}}>
            Connect with volunteers, request help, organize events — AI-powered community support for everyone, everywhere.
          </p>
          <div style={{display:'flex',gap:'12px',justifyContent:'center',flexWrap:'wrap'}}>
            <Link to="/signup" className="btn btn-primary" style={{fontSize:'16px',padding:'14px 32px'}}>🤝 Become a Volunteer</Link>
            <Link to="/signup" className="btn btn-orange" style={{fontSize:'16px',padding:'14px 32px'}}>🆘 Request Help</Link>
          </div>
        </div>
        <div className="grid3" style={{marginBottom:'4rem'}}>
          {[{icon:'👥',num:'2,400+',label:'Active Volunteers'},{icon:'🆘',num:'890+',label:'Requests Fulfilled'},{icon:'📅',num:'340+',label:'Events Organized'},{icon:'⭐',num:'4.9',label:'Avg Trust Score'},{icon:'🌍',num:'50+',label:'Countries'},{icon:'🏘',num:'120+',label:'Communities'}].map((s,i)=>(
            <div key={i} className="stat-card">
              <div style={{fontSize:'32px',marginBottom:'8px'}}>{s.icon}</div>
              <div className="stat-num">{s.num}</div>
              <div className="stat-label">{s.label}</div>
            </div>
          ))}
        </div>
        <div style={{marginBottom:'4rem'}}>
          <h2 style={{textAlign:'center',fontSize:'32px',fontWeight:800,marginBottom:'2rem'}}>How it works</h2>
          <div className="grid3">
            {[{icon:'📝',title:'Sign Up & Verify',desc:'Create profile, upload ID, get verified by admin for a trusted community experience.'},{icon:'🔍',title:'Find or Post Help',desc:'Browse requests near you or post your own. Filter by location, category and budget.'},{icon:'⭐',title:'Complete & Rate',desc:'Help your neighbor, get rated and build your community trust score over time.'}].map((s,i)=>(
              <div key={i} className="card" style={{textAlign:'center'}}>
                <div style={{fontSize:'48px',marginBottom:'12px'}}>{s.icon}</div>
                <h3 style={{fontSize:'18px',fontWeight:700,marginBottom:'8px'}}>{s.title}</h3>
                <p style={{fontSize:'14px',color:'#6B7280',lineHeight:1.6}}>{s.desc}</p>
              </div>
            ))}
          </div>
        </div>
        <div style={{background:'linear-gradient(135deg,#166534,#EA580C)',borderRadius:'24px',padding:'3rem',textAlign:'center',color:'white',marginBottom:'2rem'}}>
          <h2 style={{fontSize:'32px',fontWeight:800,marginBottom:'1rem'}}>🆘 Emergency SOS</h2>
          <p style={{fontSize:'16px',opacity:.9,marginBottom:'1.5rem'}}>In urgent situations, our SOS button instantly notifies all volunteers within 10km radius.</p>
          <div style={{background:'rgba(255,255,255,.2)',borderRadius:'16px',padding:'1rem',display:'inline-block'}}>
            <span style={{fontSize:'14px',fontWeight:600}}>Available to all verified members</span>
          </div>
        </div>
      </div>
      <footer style={{textAlign:'center',padding:'2rem',color:'#6B7280',borderTop:'1px solid #D1FAE5'}}>
        CommunityBridge AI &mdash; Stronger Together &copy; 2025
      </footer>
    </div>
  );
}
